import { connect } from 'react-redux';
import ConnectionsPanel from './connectionsPanel';

function mapStateToProps(state) {
  const { connections: { data = {} } } = state;
  return {
    connections: data,
  };
}

export default connect(mapStateToProps)(ConnectionsPanel);
